const _excluded = ["onClick", "href", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from '.';
export function ExternalLinkButton(_ref) {
  let {
      onClick,
      href,
      text
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const openExternalPageInNewTab = e => {
    // Prevent default anchor navigation so we can add security flags.
    e.preventDefault();
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }

    // Preserve any caller-supplied onClick.
    onClick && onClick(e);
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    onClick: openExternalPageInNewTab,
    "data-testid": "external_link_button",
    href: href,
    icon: "launch",
    target: "_blank",
    rel: "noopener noreferrer",
    iconPosition: "right"
  }, props), text);
}